
import { defineComponent, onMounted, ref } from 'vue';
import VuePdfEmbed from 'vue-pdf-embed';
import AppLoader from '@/components/UI/AppLoader.vue';

export default defineComponent({
  props: {
    videoUrl: { type: String, required: true },
  },
  components: {
    VuePdfEmbed,
    AppLoader,
  },
  setup() {
    const pdfLoading = ref(true);
    const pdfRef = ref();
    const page = ref(1);
    const pageCount = ref(1);
    const width = ref(0);

    function handleDocumentRender() {
      pdfLoading.value = false;
      pageCount.value = pdfRef.value.pageCount;
    }

    onMounted(() => {
      const PV = document.getElementById('refWrap');
      let AR;
      if (PV) {
        AR = PV.offsetHeight / PV.offsetWidth;
      }

      // eslint-disable-next-line no-nested-ternary
      width.value = window.innerHeight > 667
        ? document.getElementById('refWrap')!.offsetWidth + 40
        : window.innerWidth < 414 && AR < 1.414
          ? document.getElementById('refWrap')!.offsetWidth - 60
          : document.getElementById('refWrap')!.offsetWidth;
    });
    return {
      pdfLoading,
      pdfRef,
      page,
      pageCount,
      width,
      handleDocumentRender,
    };
  },
});
